import { GameScene } from "../../scenes/GameScene";
import Timescale from "../../utils/Timescale";
import { Player } from "../Player";
import CharacterAtlas from "./CharacterAtlas";


export enum PlayerStateTypes {
    Idle = "Idle",
    Launch = "Launch",
    Fall = "Fall",
    Batarang = "Batarang",
    Fly = "Fly",
    Firecracker = "Firecracker",
    RollerSkates = "RollerSkates",
    NegHit = "NegHit",
    Crash = "Crash",
    SmashFail = "SmashFail",
    SmashThroughWall = "SmashThroughWall",
}

export default class PlayerState {
    scene: GameScene;
    player: Player;
    imgPrefix: string;
    type: PlayerStateTypes;
    currentTimer: number;

    private static SHUTDOWNCALL = "PlayerState-ShutDown"
    private static FINALCLEANUP = "PlayerState-FinalCleanup"

    /**
     * Generic PlayerState constructor
     * @param player The player to apply images / listen to the events of
     * @param imgPrefix Character + costume image prefix, i.e. "bugsBatman"
     * @param type Type of state this is, set by children
     */
    constructor(player: Player, imgPrefix: string, type: PlayerStateTypes) {
        this.scene = player.scene;
        this.player = player;
        this.imgPrefix = imgPrefix;
        this.type = type;
        this.currentTimer = 0;
        this.player.once(this.type, this.beginState, this);
        this.player.on(PlayerState.FINALCLEANUP, this.finalCleanup, this);
    }

    /**
     * Set up state specific listeners, set player image, and enable the shutdown listener
     */
    beginState(): void {
        this.player.emit(PlayerState.SHUTDOWNCALL);
        // console.log("Starting " + this.imgPrefix + this.type);
        this.player.currentState = this;
        this.player.img.setTexture(this.imgPrefix, CharacterAtlas.characters[this.imgPrefix][this.type]);
        this.player.img.setScale(this.player.character.scale ? this.player.character.scale : 0.6);
        this.currentTimer = 0;
        this.player.off(this.type, this.beginState, this);
        this.player.once(PlayerState.SHUTDOWNCALL, this.shutDown, this);
    }

    update(dt: number): void {
        // update passed by player
        if (this.currentTimer > 0) {
            this.currentTimer -= dt;
            // console.log(this.currentTimer)
            if (this.currentTimer < 0) {
                this.timerCallback();
            }
        }
    }

    timerCallback() {
        // console.log("Timer callback for " + this.imgPrefix + this.type);
    }

    /**
     * starts the timer for timerCallback
     * @param seconds time in seconds until timerCallback is triggered, as long as this is still the active state
     */
    startTimer(seconds: number): void {
        this.currentTimer = seconds;
    }

    /**
     * stop all active listeners, then listen for startup
     */
    shutDown(): void {
        // console.log("Stopping " + this.imgPrefix + this.type);
        this.currentTimer = 0;
        this.player.off(PlayerState.SHUTDOWNCALL, this.shutDown, this);
        this.player.once(this.type, this.beginState, this);
    }

    /**
     * Remove all listeners for the last time 
     */
    finalCleanup(): void {
        // console.log("Final cleanup " + this.imgPrefix + this.type);
        this.player.off(PlayerState.SHUTDOWNCALL, this.shutDown, this);
        this.player.off(this.type, this.beginState, this);
    }
}